/**
 * @generated SignedSource<<7561d08cc37e46b536c1c78bb2ae72bb>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type DisableQuickbooksIntegrationInput = {
  realmId?: string | null;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type disableQuickbooksIntegrationMutation$variables = {
  input: DisableQuickbooksIntegrationInput;
};
export type disableQuickbooksIntegrationMutation$data = {
  readonly disableQuickbooksIntegration: {
    readonly company: {
      readonly quickbooksEnabled: boolean | null;
    } | null;
  } | null;
};
export type disableQuickbooksIntegrationMutation = {
  variables: disableQuickbooksIntegrationMutation$variables;
  response: disableQuickbooksIntegrationMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "quickbooksEnabled",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "disableQuickbooksIntegrationMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "DisableQuickbooksIntegrationPayload",
        "kind": "LinkedField",
        "name": "disableQuickbooksIntegration",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Company",
            "kind": "LinkedField",
            "name": "company",
            "plural": false,
            "selections": [
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "disableQuickbooksIntegrationMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "DisableQuickbooksIntegrationPayload",
        "kind": "LinkedField",
        "name": "disableQuickbooksIntegration",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Company",
            "kind": "LinkedField",
            "name": "company",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "844ced60db8e4e5f114542e09cfc1a51",
    "id": null,
    "metadata": {},
    "name": "disableQuickbooksIntegrationMutation",
    "operationKind": "mutation",
    "text": "mutation disableQuickbooksIntegrationMutation(\n  $input: DisableQuickbooksIntegrationInput!\n) {\n  disableQuickbooksIntegration(input: $input) {\n    company {\n      quickbooksEnabled\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "3faaedb8f68a6ad118573ad9a7f3c743";

export default node;
